import { Component, Renderer2 } from '@angular/core';
import { RouterOutlet, Router, RouterLink } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { MatSnackBar } from '@angular/material/snack-bar';
import { AuthenticationServicesService } from './services/auth-services/authentication-services.service';
import { ToasterComponent } from './components/shared/toaster/toaster.component';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrl: './app.component.scss',
})
export class AppComponent {
  loading: boolean = false;
  title = 'online-ordering';
  language = localStorage.getItem('language');
  subdomain: string = '';
  constructor(
    private translationService: TranslateService,
    private authenticationService: AuthenticationServicesService,
    private renderer: Renderer2
  ) {
    const manifestData = JSON.parse(
      localStorage.getItem('manifestData') || '{}'
    );
    if (manifestData.logo && manifestData.name) {
      this.updateManifest(manifestData.logo, manifestData.name);
    }
  }

  ngOnInit(): void {
    if (!window.location.host.includes('localhost')) {
      this.subdomain = window.location.host.split('.')[0];
      localStorage.setItem('subdomain', this.subdomain);
    }
    else{
            localStorage.setItem('subdomain', 'bittersweet');

    }

    if (!this.language) localStorage.setItem('language', 'en');
    document
      .getElementById('body')
      ?.setAttribute('dir', this.language == 'ar' ? 'rtl' : 'ltr');
    this.translationService.use(this.language ?? 'en');

    let subdomain = localStorage.getItem('subdomain') ?? '';
    this.getRestaurantBySubdomain(subdomain);
  }

  getRestaurantBySubdomain(subdomain: string) {
    this.authenticationService.getRestaurantBySubdomain(subdomain).subscribe({
      next: (res: any) => {
        const restaurantData = res?.data?.restaurants;
        localStorage.setItem('restaurantData', JSON.stringify(restaurantData));

        const manifestData = {
          logo: restaurantData?.logo ?? 'assets/icons/sonic.png',
          name: restaurantData?.display_name ?? 'Online Ordering',
        };
        localStorage.setItem('manifestData', JSON.stringify(manifestData));

        this.updateTheme(res?.data?.restaurants?.identity_color); // Update main color

        this.updateAppDetails(
          // update app title , favicon and manifest (PWA)
          res?.data?.restaurants?.logo ?? 'assets/icons/sonic.png',
          res?.data?.restaurants?.display_name ?? 'Online Ordering'
        );
      },
      error: (err) => {},
    });
  }

  updateTheme(color: string) {
    document.documentElement.style.setProperty('--main-color', color);
  }

  updateAppDetails(logo: any, name: any) {
    document.title = name;
    this.updateFavicon(logo);
    this.updateManifest(logo, name);
  }

  updateFavicon(faviconUrl: string) {
    // Update standard favicon (for web/Android)
    let faviconLink: HTMLLinkElement =
      document.querySelector("link[rel~='icon']") ||
      this.renderer.createElement('link');
    faviconLink.rel = 'icon';
    faviconLink.type = 'image/png'; // Match your Base64 type
    faviconLink.href = faviconUrl;
    this.renderer.appendChild(document.head, faviconLink);

    // Add/update apple-touch-icon for iOS
    let appleIconLink: HTMLLinkElement =
      document.querySelector("link[rel='apple-touch-icon']") ||
      this.renderer.createElement('link');
    appleIconLink.rel = 'apple-touch-icon';
    appleIconLink.href = faviconUrl; // Use same Base64 URL
    this.renderer.appendChild(document.head, appleIconLink);
  }

  updateManifest(newIconPath: string, name: string) {
    const manifest = document.querySelector(
      'link[rel="manifest"]'
    ) as HTMLLinkElement;
    const baseUrl = window.location.origin;
    if (manifest) {
      const manifestJSON = {
        name: name,
        short_name: name,
        icons: [
          {
            src: newIconPath,
            sizes: '192x192',
            type: 'image/png',
          },
          // {
          //   src: newIconPath,
          //   sizes: '512x512',
          //   type: 'image/png',
          // },
        ],
        theme_color: '#ffffff',
        background_color: '#ffffff',
        display: 'standalone',
        start_url: `${baseUrl}/`,
      };

      const jsonString = JSON.stringify(manifestJSON);
      const blob = new Blob([jsonString], { type: 'application/json' });
      const url = URL.createObjectURL(blob);

      if ('serviceWorker' in navigator) {
        navigator.serviceWorker.getRegistration().then((registration) => {
          if (registration) {
            registration.unregister().then(() => {
              navigator.serviceWorker.register('/ngsw-worker.js');
            });
          }
        });
      }
      manifest.href = url;
    }
  }
}
